const initState = {
    type: '',
    userList: [],
    currentUser: null,
    loginUser: null,
    response: null,
    error: null
}

const userReducer = (state = initState, action) => {

    switch (action.type) {
        case 'USER_INIT':             return { ...state, type: action.type, error: null, currentUser: action.payload}
        case 'USER_LOGOUT':           return { ...state, type: action.type, error: null, loginUser: null}

        case 'USER_LOGIN_PENDING':    return { ...state, type: action.type, error: null }
        case 'USER_LOGIN_SUCCESS':    {
            return { 
                ...state, 
                type: action.type, 
                error: null,
                loginUser: {
                    ...action.payload,
                    _role: action.payload.role,
                    // backward compatibility
                    ...(['Superadmin', 'Moderator'].includes(action.payload.role) && { role: 'Admin' }),
                }
            }
        }
        case 'USER_LOGIN_ERROR':      return { ...state, type: action.type, error: action.payload }

        case 'USER_LIST_PENDING':     return { ...state, type: action.type, error: null }
        case 'USER_LIST_SUCCESS':     return { ...state, type: action.type, error: null, userList: action.payload}
        case 'USER_LIST_ERROR':       return { ...state, type: action.type, error: action.payload, userList: [] }

        case 'USER_SELECT_PENDING':   return { ...state, type: action.type, error: null }
        case 'USER_SELECT_SUCCESS':   return { ...state, type: action.type, error: null, currentUser: action.payload}
        case 'USER_SELECT_ERROR':     return { ...state, type: action.type, error: action.payload }

        case 'USER_CREATE_PENDING':   return { ...state, type: action.type, error: null }
        case 'USER_CREATE_SUCCESS':   return { ...state, type: action.type, error: null, currentUser: action.payload}
        case 'USER_CREATE_ERROR':     return { ...state, type: action.type, error: action.payload }

        case 'USER_UPDATE_PENDING':   return { ...state, type: action.type, error: null }
        case 'USER_UPDATE_SUCCESS':   return { ...state, type: action.type, error: null, response: action.payload}
        case 'USER_UPDATE_ERROR':     return { ...state, type: action.type, error: action.payload }

        case 'USER_DELETE_PENDING':   return { ...state, type: action.type, error: null }
        case 'USER_DELETE_SUCCESS':   return { ...state, type: action.type, error: null, response: action.payload}
        case 'USER_DELETE_ERROR':     return { ...state, type: action.type, error: action.payload }
        
        default: return state;
    }
};

export default userReducer;